"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterWizardStep = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const react_styles_1 = require("@patternfly/react-styles");
require("./ClusterWizardStep.css");
const ClusterWizardStep = ({ navigation, footer, children, }) => {
    return (react_1.default.createElement("div", { className: (0, react_styles_1.css)('pf-v5-c-wizard__outer-wrap', 'cluster-wizard-step') },
        react_1.default.createElement("div", { className: (0, react_styles_1.css)('pf-v5-c-wizard__inner-wrap') },
            navigation,
            react_1.default.createElement(react_core_1.WizardBody, { "aria-labelledby": "step-id", hasNoPadding: false }, children)),
        footer && react_1.default.createElement("div", { className: "pf-v5-c-wizard__footer cluster-wizard-step__footer" }, footer)));
};
exports.ClusterWizardStep = ClusterWizardStep;
// export default ClusterWizardStep;
//# sourceMappingURL=ClusterWizardStep.js.map